// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"f0787e6a","405":"c2e38cf1","708":"2203f0a0"}[chunkId] + ".chunk.css";
};